import { useApi, useMount } from "hooks";
import React, { useCallback } from "react";
import lang from "translations";
import ResourceTypeForm from "../resource-type-form/resource-type-form";
import { createResourceType } from "apis";
import { resourceTypeRequest } from "mappers";
import { mixpanel, TrackEvent } from "mixpanel";

const CreateResourceType = () => {
  const { request, loading: submitting } = useApi({
    api: createResourceType,
    handleOwnError: {
      badrequest: true,
    },
    paramsMapper: resourceTypeRequest,
  });

  useMount(() => {
    mixpanel.track(TrackEvent.VisitedPage, {
      Page: lang.createResourceType,
    });
  });

  const submitForm = useCallback(
    async (params) => {
      try {
        const res = await request(params);
        return {
          response: res,
          message: lang.populate(lang.resourceTypeCreated, [params.name]),
        };
      } catch (e) {
        throw e;
      }
    },
    [request]
  );

  return <ResourceTypeForm submit={submitForm} title={lang.createNewResourceType} submitting={submitting} />;
};

export default CreateResourceType;
